<!--
 * @Author: Merlin
 * @Date: 2024-01-16 09:53:32
 * @LastEditors: Merlin
 * @LastEditTime: 2024-11-29 13:15:17
 * @Description: 
-->
<template>
    <figure class='poker'
        :class="{
            big: !!big,
            failed: !!failed
        }"
    >
        <div class='poker-inner' v-if="iCardNo">
            <span class="number" >
                {{ aPokerList[iCardNo].slice(1) }}
            </span>
            <IconSvgUse fileName="hilo"
                width="40%"
                height="40%"
                :use="'hilo-' + suitName"
            > </IconSvgUse>
        </div>
    </figure>
</template>

<script setup lang="ts">
import {aPokerList} from '../js/hiloConstant.js';

const props = defineProps({
    iCardNo: Number, // 1-52
    big: {
        type: Boolean,
    },
    failed: {
        type: Boolean,
    },
});

const obj = {
    "♥": 'heart',
    "♣": 'club',
    "♠": 'spade',
    "♦": 'diamond',
};



// 取得：♠, ♦, ♣, ♥ 
const suitMark = computed(()=>{
    return aPokerList[props.iCardNo]?.[0] || '';
});

// 取得：heart, club, spade, diamond
const suitName = computed(()=>{
    return obj[suitMark.value] || '';
});

const color = computed(() => {
    const beRed = ['♦', '♥'].includes(suitMark.value);
    const sColor = beRed ? '#f04051' : '#26292f';
    return sColor;
});

</script>

<style scoped lang="scss">
.poker{
    --width: 40px;
    width: var(--width);
    height: calc(var(--width) * 1.4);
    background-image: url('../img/card.svg');
    background-size: 100% 100%;
    border-radius: 4px;
    overflow: hidden;
    font-size: 18px;
    transition: all 0.6s;
    transition-delay: 0.5s;
    box-shadow: 0px 0px 0px 6px transparent;
    &[class~=big]{
        width: 100%;
        height: 100%;
        border-radius: 10px;
        font-size: 72px;
    }
    &[class~=failed]{
        box-shadow: 0px 0px 0px 6px #c84252;
    }
}

.poker-inner{
    width: 100%;
    height: 100%;
    background-color: white;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    .number{
        color: v-bind('color');
        font-weight: bold;
        line-height: 1;
    }
    & > svg{
        margin: 0.1em 0 0;
    }
}
</style>

